<template>
  <div class="card my-3 px-3 py-3" style="width: 65vw; padding: 1rem;">
    <h5 style="color: #000; align-self: center">{{ title }}</h5>
    <apexchart type="bar" width="100%" :options="chartOptions" :series="series"></apexchart>
  </div>
</template>

<script>
export default {
  props: ['title', 'values', 'categories', 'catramal', 'plot_options', 'yaxis', 'colors'],
  data: function() {
    return {
      chartOptions: {
        chart: {
          id: "barchart",
            toolbar: {
              show: false,
            },
        },
        plotOptions: this.plot_options ?? {
          bar: {
            distributed: true,
            dataLabels: {
              position: 'top'
            }
          },
        },
        theme: {
          palette: "palette7",
        },
        stroke: {
          colors: ['transparent'],
        },
        xaxis: {
          categories: this.categories,
          overwriteCategories: this.catramal
        },
        tooltip: {
          theme: 'dark',
        },
        yaxis: this.yaxis ?? {
          show: true,
          min: 10,
          stepSize: 10
        },
        ...( this.colors ? { colors: this.colors } : {} ),
      },
     

      series: this.values
    };
  }
};
</script>